import { render, staticRenderFns } from "./testPath.vue?vue&type=template&id=31de5f40&scoped=true&"
import script from "./testPath.vue?vue&type=script&lang=js&"
export * from "./testPath.vue?vue&type=script&lang=js&"
import style0 from "./testPath.vue?vue&type=style&index=0&id=31de5f40&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31de5f40",
  null
  
)

export default component.exports